import { useCurrentUser } from '../../services/userHooks';
import { buildSaveEmail } from '../../utils/inboundEmail';
import CopyableEmail from './CopyableEmail';

/**
 * Intro sentence for the Email docs page. When signed in we show the real Save
 * to Instapaper address inline; logged out we explain that it appears here once
 * the reader logs in.
 */
function SaveEmailIntro() {
  const { currentUser } = useCurrentUser();
  const saveEmail = buildSaveEmail(currentUser);

  if (saveEmail) {
    return (
      <>
        You can email newsletters, threads, or plain text to your account using your{' '}
        <strong>Save to Instapaper</strong> email address:{' '}
        <CopyableEmail email={saveEmail} />
      </>
    );
  }

  return (
    <>
      You can email newsletters, threads, or plain text to your account using your{' '}
      <strong>Save to Instapaper</strong> email address. When you're{' '}
      <a
        href="https://www.instapaper.com/user/login"
        className="docs-link"
        target="_blank"
        rel="noopener noreferrer"
      >
        logged in
      </a>
      , your Save to Instapaper Email address will show here.
    </>
  );
}

export default SaveEmailIntro;
